<template>
  <Line :data="data" :options="options" />
</template>

<script>
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default {
  name: 'BasicPercentageLineChart',

  components: {
    Line
  },

  props: {
    chartData: { type: Object },
    chartOptions: { type: Object }
  },

  data() {
    return {
      toolTipDelay: { delay: { "show": 500, "hide": 100 } },
      currentWidth: undefined,
      data: {
        labels: ['Wave1', 'Wave2', 'Wave3', 'Wave4', 'Wave5', 'Wave6', 'Wave7'],
        datasets: [{
          label: 'SurveyWaves',
          backgroundColor: 'rgba(51, 51, 51, 0.7)',
          borderColor: 'rgba(51, 51, 51, 0.7)',
          pointBackgroundColor: ['#ff1500', '#ffd800', '#4cff00', '#ff1500', '#ffd800', '#4cff00', '#ff1500'],
          pointBorderColor: ['#ff1500', '#ffd800', '#4cff00', '#ff1500', '#ffd800', '#4cff00', '#ff1500'],
          pointRadius: 4,
          pointHoverRadius: 5,
          data: [32.12, 77.77, 0, 99.99, 33.33, 63.32, 23.99],
          fill: false,
        }]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
            min: 0,
            max: 100,
            ticks: {
              stepSize: 25
            }
          },
          x: {
            ticks: { display: false }
          }
        },
        plugins: {
          legend: { display: false }
        },
        elements: {
          line: { tension: 0 }
        },
        animation: { duration: 0 },
        hover: { animationDuration: 0 },
        responsive: true,
        responsiveAnimationDuration: 0,
        maintainAspectRatio: false,
        layout: {
          padding: {
            right: 5
          }
        },
      }
    };
  },

  mounted() {
    if (this.chartData) {
      this.data = this.chartData;
    }
    if (this.chartOptions) {
      this.options = this.chartOptions;
    }
  },
};
</script>
